<template>
  <div>
    <el-alert class="alert" title type="info" :closable="false" show-icon>
      <span>地址信息必须包含省市区和详细地址。一次最多查询20条数据，请用 换行 或 ; 隔开</span>
    </el-alert>
    <el-form
      label-width="142px"
      class="y-mt-15 y-p-r"
      :model="searchModel">
      <el-form-item label="请选择快递公司" required>
        <el-select class="y-w-120" size="mini" v-model="searchModel.logisticsCode">
          <el-option
            v-for="item in expressList"
            :key="item.code"
            :value="item.code"
            :label="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="searchModel.logisticsCode === 'YTO'">
        <span slot="label">
          <span style="padding-left: 11px">寄件地址</span>
          <span @click="senderModel = 1" class="radio-btn" :class="{'active-radio-btn': senderModel==1}">选</span>
          <span @click="senderModel = 2" class="radio-btn" :class="{'active-radio-btn': senderModel==2}">填</span>
        </span>
        <template v-if="senderModel == 1">
          <el-select
            size="mini"
            class="y-w-300"
            v-model="addressId"
            filterable
            @change="handleChange"
            placeholder="请输入寄件地址">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </template>
        <template v-if="senderModel == 2">
          <el-select
            class="y-w-120"
            size="mini"
            filterable
            v-model="searchModel.senderProvince"
            placeholder="请选择省"
            clearable
            @change="(val) => getAreaList(val, 'province')">
            <el-option v-for="item in provinceList" :key="item.value" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
          <el-select
            class="y-w-120 y-ml-5"
            size="mini"
            filterable
            v-model="searchModel.senderCity"
            placeholder="请选择市"
            clearable
            @change="(val) => getAreaList(val, 'city')">
            <el-option v-for="item in cityList" :key="item.value" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
          <el-select
            class="y-w-120 y-ml-5"
            size="mini"
            filterable
            v-model="searchModel.senderCounty"
            placeholder="请选择区"
            clearable
            @change="(val) => getAreaList(val, 'county')">
            <el-option v-for="item in countyList" :key="item.value" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
          <el-input
            class="y-w-232 y-ml-5"
            size="mini"
            v-model.trim="searchModel.senderAddressDetail"
            placeholder="请输入详细地址">
          </el-input>
        </template>
        <span class="y-fs-12 y-ml-10 y-fc-4C84FF">
          <i class="el-icon-warning y-fs-14"></i>
          非必填项，填写后查询更精准
        </span>
      </el-form-item>
      <el-form-item label="收件地址" required>
        <div class="area-wrap clearfix">
          <el-input
            v-model="searchModel.addressStr"
            placeholder="请填写地址信息"
            type="textarea"
            :rows="4"
            resize="none">
          </el-input>
          <span class="clear-btn" @click="searchModel.addressStr = ''">清空</span>
        </div>
      </el-form-item>
      <div class="btn-wrap">
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button class="normal-btn" icon="el-icon-refresh-left" @click="reset">重置</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import district from '@/mixins/district';
import { checkAddressArrCanReceiveApi } from "../../../../api/baseInfo/printSetting/addressCanReceive";

export default {
  props: ['options'],
  mixins: [district],
  data() {
    return {
      expressList: [
        {
          name: '圆通速递',
          code: 'YTO'
        }, {
          name: '中通速递',
          code: 'ZTO'
        }, {
          name: '韵达快递',
          code: 'YUNDA'
        }, {
          name: '申通快递',
          code: 'STO'
        }, {
          name: '顺丰速运',
          code: 'SF'
        }, {
          name: 'EMS',
          code: 'EMS'
        }, {
          name: '邮政快递包裹',
          code: 'YZKDBG'
        }
      ],
      searchModel: {
        logisticsCode: 'YTO',
        addressStr: '',
        senderProvince: '',
        senderCity: '',
        senderCounty: '',
        senderAddressDetail: ''
      },
      senderModel: '1', // 1: 选 2: 填
      addressId: '',
      currentProName: '',
      currentCityName: '',
      currentCountyName: '',
      currentChooseProName: '',
      currentChooseCityName: '',
      currentChooseCountyName: '',
      currentChooseAddress: '',
      provinceList: [],
      cityList: [],
      countyList: [],
    }
  },
  mounted() {
    this.getDistrict('086', this.provinceList);
  },
  methods: {
    // 寄件地址变化时
    handleChange(val) {
      let selectedItem = this.options.filter(item => item.id === val);
      this.currentChooseProName = selectedItem[0].provinceName;
      this.currentChooseCityName = selectedItem[0].cityName;
      this.currentChooseCountyName = selectedItem[0].districtName;
      this.currentChooseAddress = selectedItem[0].address;
    },
    getAreaList(val, type) {
      if(!val) {
        if(type === 'province') {
          this.searchModel.senderProvince = '';
          this.currentProName = '';
          this.cityList = [];
          this.searchModel.senderCity = '';
          this.currentCityName = '';
          this.countyList = [];
          this.searchModel.senderCounty = '';
          this.currentCountyName = '';
        }
        if(type === 'city') {
          this.currentCityName = '';
          this.searchModel.senderCity = '';
          this.countyList = [];
          this.searchModel.senderCounty = '';
          this.currentCountyName = '';
        }
        if(type === 'county') {
          this.currentCountyName = '';
          this.searchModel.senderCounty = '';
        }
        return;
      }
      if(type === 'province') {
        this.currentProName = this.provinceList.filter(item => item.value === val)[0].name;
        this.cityList = [];
        this.searchModel.senderCity = '';
        this.currentCityName = '';
        this.countyList = [];
        this.searchModel.senderCounty = '';
        this.currentCountyName = '';
        this.getDistrict(val, this.cityList);
      }
      if(type === 'city') {
        this.countyList = [];
        this.searchModel.senderCounty = '';
        this.currentCountyName = '';
        this.currentCityName = this.cityList.filter(item => item.value === val)[0].name;
        this.getDistrict(val, this.countyList);
      }
      if(type === 'county') {
        this.currentCountyName = this.countyList.filter(item => item.value === val)[0].name;
      }
    },
    search() {
      let sourceData = this.searchModel.addressStr.replace(/\n/g, ';').replace(/；/g, ';').split(';');
      let addressStrList = sourceData.filter(item => item.trim());
      if(addressStrList.length <= 0) {
        this.$message.error('收件地址不能为空');
        return;
      }
      if(addressStrList.length > 20) {
        this.$message.error('一次最多查询20条数据');
        return;
      }
      let senderAddressWhole = '';
      if(this.searchModel.logisticsCode === 'YTO') {
        // 只有圆通才有寄件人地址
        if(this.senderModel == 1) {
          senderAddressWhole = this.currentChooseProName + this.currentChooseCityName + this.currentChooseCountyName + this.currentChooseAddress;
        } else {
          senderAddressWhole = this.currentProName + this.currentCityName + this.currentCountyName + this.searchModel.senderAddressDetail
        }
      }
      let params = {
        logisticsCode: this.searchModel.logisticsCode,
        addressStrList,
        senderAddressWhole
      }
      this.$emit('setLoading', true);
      checkAddressArrCanReceiveApi(params).then(res => {
        if(res.message === 'ok') {
          if(+res.data.errorNum > 0) {
            if(addressStrList.length === 1) {
              this.$message.error('必须填写省市区和详细地址，请填写');
            } else {
              this.$message.error(`${res.data.errorNum}条数据失查询失败，请完善省市区和详细地址`)
            }
          } else {
            this.$message.success('查询成功')
          }
          this.$emit('setTableData', res.data.addressUnArriveResponseList);
        } else {
          if(addressStrList.length === 1) {
            this.$emit('setTableData', []);
            this.$message.error('必须填写省市区和详细地址，请填写');
          } else {
            this.$message.error(res.error || '服务器异常');
          }
        }
        this.$emit('setLoading', false);
      })
    },
    reset() {
      this.searchModel.logisticsCode = 'YTO';
      this.searchModel.addressStr = '';
      this.addressId = '';
      this.searchModel.senderProvince = '';
      this.searchModel.senderCity = '';
      this.searchModel.senderCounty = '';
      this.searchModel.senderAddressDetail = '';
      this.$emit('setTableData', []);
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../../styles/variables";
/deep/ .el-form-item__label {
  z-index: 2;
  position: relative;
  text-align: left;
}
.radio-btn{
  width: 24px;
  height: 20px;
  border-radius: 3px;
  border: 1px solid #DCDFE6;
  font-size: 14px;
  color: #A2A5AC;
  line-height: 20px;
  padding: 0 5px;
  cursor: pointer;
}
.active-radio-btn{
  border: 1px solid $blue-style;
  font-size: 14px;
  color: $blue-style;
  line-height: 20px;
}
/deep/ .el-alert--info  {
  width: 600px;
}
.area-wrap {
  display: inline-block;
  width: 560px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  /deep/ .el-textarea__inner {
    border: none;

  }
  .clear-btn {
    float: right;
    color: $blue-style;
    cursor: pointer;
    text-align: right;
    padding-right: 8px;
  }
}
.btn-wrap {
  position: absolute;
  right: 10px;
  bottom: 10px;
}
.y-w-120 {
  width: 120px;
}
.y-w-232 {
  width: 232px;
}
</style>
